import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { Member } from "../../../types/employee.types";
import { CommonDetails, EnrollmentSchema, StandardDetails, VEBEnrollmentSchema } from "../../../types/enrollment.types";
import { LogoSettings } from "../../../types/logoSettings.types";
import { OpenEnrollment, VEBOpenEnrollment } from "../../../types/openEnrollment.types";
import { Plan } from "../../../types/plan.types";
import { Theme } from "../../../types/theme.types";
import { request } from "../api";

const initialRoute = "pages";
const { get } = request;

export const getEnrollmentInitData = async (): Promise<{
	openEnrollments: { open_enrollment: OpenEnrollment & { plan: Plan } }[];
	enrollments: (StandardDetails & CommonDetails)[];
	dependents: Member[];
	activeEnrollments: EnrollmentSchema[];
	alwaysOpenEnrollments: Plan[];
	corePlansForEmployeeClassSpecific: Plan[];
	previousEnrollments: EnrollmentSchema[];
}> => {
	try {
		const endpoint = `${initialRoute}/enrollment-init`;
		const token = localStorage.getItem("@jwt_member");
		// console.log("Enrollment Init token", token);
		const response = await get(endpoint, {
			...headers,
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;

				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		// console.log("Error_Enrollment Init Data: ", err);
		alert(`Enrollment Initial Data: ${err}`);
		throw err;
	}
};

export const getVEBEnrollmentInitData = async (): Promise<{
	VEBOpenEnrollment: VEBOpenEnrollment | null;
	VEBEnrollments: VEBEnrollmentSchema[];
	dependents: Member[];
	previousEnrollments: VEBEnrollmentSchema[];
}> => {
	try {
		const endpoint = `${initialRoute}/VEB-enrollment-init`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(endpoint, {
			...headers,
			Authorization: `Bearer ${token}`
		});
		// console.log("In Action", response);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;

				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export type AccidentPlanInitQuery = {
	VEB_open_enrollment_id: string;
};

export const getAccidentPlanInitData = async (
	accidentPlanInitQuery: AccidentPlanInitQuery
): Promise<{
	shortTermDisablityEnrollment: VEBEnrollmentSchema | null;
	latestAccidentEnrollment: VEBEnrollmentSchema | null;
}> => {
	try {
		const endpoint = `${initialRoute}/accident-plan-init`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			accidentPlanInitQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				// console.log("result", result);
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const enrollmentInit = {
	getEnrollmentInitData,
	getVEBEnrollmentInitData,
	getAccidentPlanInitData
};
